import request from '@/config/axios'

export const CatalogPublishApi = {
  getVisibility: async (params: { cityCode: string; categoryId?: number; serviceId: number }) => {
    return await request.get({ url: '/o2o/catalog/publish/visibility', params })
  }
}
